/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GetDocumentOpportunityUsersResponse1DataDocumentOpportunityUsersInnerFromJSON, GetDocumentOpportunityUsersResponse1DataDocumentOpportunityUsersInnerToJSON } from './GetDocumentOpportunityUsersResponse1DataDocumentOpportunityUsersInner';
export function GetDocumentOpportunityUsersResponse1DataFromJSON(json) {
    return GetDocumentOpportunityUsersResponse1DataFromJSONTyped(json, false);
}
export function GetDocumentOpportunityUsersResponse1DataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        documentOpportunityUsers: !exists(json, 'document_opportunity_users')
            ? undefined
            : json['document_opportunity_users'].map(GetDocumentOpportunityUsersResponse1DataDocumentOpportunityUsersInnerFromJSON)
    };
}
export function GetDocumentOpportunityUsersResponse1DataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        document_opportunity_users: value.documentOpportunityUsers === undefined
            ? undefined
            : value.documentOpportunityUsers.map(GetDocumentOpportunityUsersResponse1DataDocumentOpportunityUsersInnerToJSON)
    };
}
